import { QueryParam } from '../'

export class ObjectQueryParam extends QueryParam<object> {

  public toString(): string {
    const queryStrings = Object.keys(this.value).map((objectKey) => `${this.key}[${objectKey}]=${this.value[objectKey]}`)
    return encodeURI(queryStrings.join('&'))
  }

  public add(value: object) {
    Object.assign(this._value, value)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/models/uri/query-param/object-query-param/object-query-param.ts